import styled from "@emotion/styled";
import { Box, Tab } from "@mui/material";

export const StyledTab = styled(Tab)(
  ({ theme }) => `
  font-size: 13px;
  min-height: 40px;
  &.Mui-selected {
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
    border-radius: 12px;
  }
`
);

export const StyledBox = styled(Box)(
  ({ theme }) =>
    `
    width: 100%
    margin-top: 10px;
    border-bottom: 1px solid;
    border-color:${theme.palette.primary.main}
  `
);
